import { parseStored, API_DATE_FORMAT } from './date';

// Calendar-day comparison. Both sides are read in the offset they arrived with, so a
// course that ends on the 1st is not flagged as expired on the 31st for a viewer whose
// timezone is behind the one the API serialised. See ./date.js.
export default (date, after) => {
  const a = parseStored(date);
  const b = parseStored(after);

  if (!a || !b) return false;

  return a.format(API_DATE_FORMAT) > b.format(API_DATE_FORMAT);
};
